import { Link } from "react-router-dom";
import { AuthShell } from "../auth/AuthShell";

/** Shown when the live uplink is lost and cannot recover. */
export function ConnectionLostScreen({ onRetry }: { onRetry?: () => void }) {
  return (
    <AuthShell title="UPLINK LOST" subtitle="Connection to the signal grid interrupted">
      <div className="conn-lost">
        <div className="conn-lost-icon" aria-hidden="true">
          <svg viewBox="0 0 80 80">
            <circle cx="40" cy="40" r="30" />
            <line x1="22" y1="22" x2="58" y2="58" />
          </svg>
        </div>
        <p className="auth-copy">
          The secure WebSocket to <b>api.earlywire.io</b> could not be re-established. The desk is
          attempting to reconnect automatically. If this persists, check your network or VPN, or
          confirm the service status.
        </p>
        <div className="acct-actions">
          <button className="auth-btn primary" onClick={() => (onRetry ? onRetry() : window.location.reload())}>
            RETRY UPLINK
          </button>
          <Link className="auth-btn" to="/">
            HOME
          </Link>
        </div>
      </div>
    </AuthShell>
  );
}

export function NotFoundScreen() {
  return (
    <AuthShell title="OFF GRID" subtitle="404 · no such coordinate">
      <p className="auth-copy">This route isn't on the plot.</p>
      <Link className="auth-btn primary" to="/">
        RETURN TO BASE
      </Link>
    </AuthShell>
  );
}
